var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarTrainingGames(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4003 5.37882C16.6095 5.37882 17.5898 4.39859 17.5898 3.18941C17.5898 1.98023 16.6095 1 15.4003 1C14.1912 1 13.2109 1.98023 13.2109 3.18941C13.2109 4.39859 14.1912 5.37882 15.4003 5.37882Z",
    stroke: "#333333",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99949 12.2749C4.24348 12.7116 3.27579 12.4528 2.83912 11.6955C2.40244 10.9395 2.6613 9.97183 3.41852 9.53516",
    stroke: "#333333",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4186 13.2744C21.7661 13.2744 22.7193 11.5894 21.2871 10.2116C21.2218 10.1487 21.1347 10.1112 21.044 10.1112H17.5192C17.4345 10.1112 17.3534 10.0798 17.2893 10.0241L13.7028 6.8283C13.6399 6.77145 13.5577 6.74121 13.473 6.74121H8.08775C8.02485 6.74121 7.96195 6.75814 7.90752 6.79201L3.41016 9.53664",
    stroke: "#333333",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8829 23.591C10.5381 24.393 10.9083 25.3232 11.7114 25.668C12.5146 26.0127 13.4436 25.6426 13.7884 24.8394L16.2657 19.2231C16.2657 19.2231 16.6019 18.5494 16.4906 18.1006C16.3794 17.6518 16.2657 17.3143 15.7044 16.9781L12.3731 14.8963C12.2243 14.8032 12.1687 14.6133 12.2449 14.4548L13.5053 11.8202C13.6021 11.617 13.8646 11.5602 14.0363 11.7041L15.8314 13.1944C15.8931 13.2452 15.9717 13.2742 16.0516 13.2742H20.4171",
    stroke: "#333333",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.03995 19.1987C1.21983 19.4974 0.796459 20.4059 1.09644 21.226C1.39522 22.0461 2.30364 22.4695 3.12377 22.1695L9.52023 19.6087C9.59886 19.5773 9.66297 19.518 9.70046 19.443L10.4795 17.885C10.5714 17.7012 10.8036 17.6383 10.9766 17.7495L12.6519 18.8382C12.7935 18.9301 12.8479 19.1116 12.7802 19.2664L10.8774 23.6005",
    stroke: "#333333",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99577 12.2771L8.83147 9.95584C8.88591 9.92319 8.9476 9.90625 9.0105 9.90625H10.2685C10.5237 9.90625 10.6907 10.1748 10.5782 10.4034L7.34485 16.9716C7.30735 17.0478 7.24324 17.1083 7.16341 17.1398L1.97656 19.2239",
    stroke: "#333333",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26 24C26 25.6568 24.6568 27 23 27C21.3432 27 20 25.6571 20 24C20 22.3429 21.3432 21 23 21C23.2874 21 23.5656 21.0403 23.8288 21.1159C25.0826 21.4756 26 22.6306 26 24Z",
    stroke: "#333333",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1484 23.029C21.1484 23.029 21.2955 22.2937 21.7073 21.9113C22.119 21.529 23.1484 21.4996 23.3249 21.529C23.5014 21.5584 24.1778 22.3231 24.1778 22.3231L23.5896 23.9113L22.2367 24.176L21.1484 23.029Z",
    stroke: "#333333",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1457 23.0293C21.1457 23.0293 20.4398 23.2352 20.3221 23.4411C20.2045 23.6469 20.1457 24.9116 20.2339 25.0587C20.3221 25.2058 21.028 25.8528 21.028 25.8528C21.028 25.8528 21.0495 26.2911 21.1418 26.3661",
    stroke: "#333333",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2645 22.7646C20.2645 22.7646 20.2351 23.1764 20.3233 23.4411",
    stroke: "#333333",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0293 25.8523L22.1469 25.4111L22.2352 24.1758",
    stroke: "#333333",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.585 23.8789L24.2935 24.9998L23.3818 25.9998L22.1465 25.4116",
    stroke: "#333333",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.616 26.9405L23.3828 25.999",
    stroke: "#333333",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2934 25.0014L25.5287 24.8838C25.5287 24.8838 25.9699 23.8544 25.9405 23.5603C25.9111 23.2661 25.1464 22.3838 24.9699 22.325C24.7934 22.2661 24.1758 22.325 24.1758 22.325",
    stroke: "#333333",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.498 25.6553C25.498 25.6553 25.6178 25.0279 25.5295 24.8809",
    stroke: "#333333",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3242 21.5286C23.3242 21.5286 23.5951 21.1718 23.9448 21.1592",
    stroke: "#333333",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0016 22.3234C25.0016 22.3234 24.8833 21.7278 24.6777 21.5107",
    stroke: "#333333",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7346 21.8524C21.5484 21.7838 21.362 21.715 21.1758 21.6465",
    stroke: "#333333",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarTrainingGames);
export default __webpack_public_path__ + "static/media/sidebar-training-games.9b47170887238926d46dbb39c3ebce48.svg";
export { ForwardRef as ReactComponent };